import * as yup from 'yup';

export const validationSchema = yup.object({
  file: yup
    .mixed<File>()
    .nullable()
    .required('Необходимо выбрать файл')
    .test('fileType', 'Допустимы только Excel файлы (.xls, .xlsx)', (value) => {
      if (!value) {
        return true;
      }

      if (!(value instanceof File)) {
        return false;
      }

      const allowedExtensions = ['.xls', '.xlsx'];
      const fileName = value.name.toLowerCase();

      return allowedExtensions.some((ext) => fileName.endsWith(ext));
    }),
});
